import { Component, ViewChild, Input, Inject, AfterViewInit, OnInit, EventEmitter, DOCUMENT } from '@angular/core';
import { environment } from '../../../environments/environment';

import { GenericService } from '../../../common/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataService } from '../../../common/data.service';
import { HttpClient, HttpResponse, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LazyLoadingService } from '../../../common/lazyloading';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { FAScoringModelFinancialView, APIParam, QuantitativeGroup } from '../WFScoringQuantitativeDetail/WFScoringQuantitativeDetail.model'
import { JSONCurrentInstanceData } from '../../WorkflowDashBoard.model';
import { UtilityService } from '../../../common/utility.service';


@Component({
    selector: 'app-ScoringQuantitativeDetail-Component',
    templateUrl: './WFScoringQuantitativeDetail.component.html',
    styleUrls: ['./WFScoringQuantitativeDetail.component.css'],
    outputs: ['onInitialized'],
    standalone: false
})
///Component can be integrated with parent component 
export class ScoringQuantitativeDetail implements OnInit {



  public documentURL: string;
  public urlAarray: string[];
  public baseURL: string;
  public hostname: string;
  public __sGetApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public userName: string;
  public __oInstanceAllStateData: JSONCurrentInstanceData[] = [];
  public __sScoringModelName: string = '';
  public __oQuantitativeGroup: QuantitativeGroup[] = [];
  public __oQuantitativeScoreCardGroup: QuantitativeGroup[] = [];
  public __oQuantitativeView: string = 'Score Card Group';
  public __oQuantitativeViews: any[];
  public __bIsLoadingVisible: boolean = false;
  public __sExchangeRateWarningMessage: string = '';


  onInitialized = new EventEmitter<ScoringQuantitativeDetail>();

  @Input()
  __sInstanceId: number = 0;

  @Input()
  __sStateDataId: number = 0;

  @Input()
  __sValue: any = "";

  @Input()
  __sDataCaption: string = "";

  @Input()
  __sQuantitativeControlState: string = "";

  @Input()
  __sScoringModel: string = "";

  @Input()
  __sBasePeriod: string = "";

  @Input()
  __sPeriod: string = "";

  @Input()
  __sTradingCounterparty: string = "";

  @Input()
  __bReadOnly: number = 0;

  @Input()
  __sQuantitativeControl: string = "";



  public __oFAScoringModelFinancialView: FAScoringModelFinancialView[] = [];

  constructor(@Inject(DOCUMENT) public document: any, public service: GenericService, public route: ActivatedRoute, public router: Router, public data: DataService, public http: HttpClient, public __oUtilityService: UtilityService, public datePipe: DatePipe, public lazyLoadingService: LazyLoadingService) {
    let sViews: any[] = [
      {
        id: 0,
        text: "Score Card Group"
      },
      {
        id: 1,
        text: "Financial Group"
      }
    ];

    this.__oQuantitativeViews = sViews;
  }

  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {
    this.onInitialized.emit(this);

  }

  /// Events

  public TextAreaOnChange(e: any) {

    let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialViewId == e);    

    if (oExistFAScoringModelFinancialView.IsScored == 1) {
      this.__bIsLoadingVisible = true;
      let oFinancials: FAScoringModelFinancialView[] = this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup == oExistFAScoringModelFinancialView.FAScoreCardGroup);

      let oAPIParam: APIParam = new APIParam();
      oAPIParam.oFAScoringModelFinancialView = oFinancials;

      this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateFinancialFactorScore").then(
        result => this.OnSuccessGetFAScoringModelFinancialForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelFinancial(error))
    }

  }

  public TextAreaOnChangeOriginal(e: any) {

    let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialViewId == e);

    oExistFAScoringModelFinancialView.AdjustedValue = oExistFAScoringModelFinancialView.OriginalValue;

    if (oExistFAScoringModelFinancialView.IsScored == 1) {
      this.__bIsLoadingVisible = true;
      let oFinancials: FAScoringModelFinancialView[] = this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup == oExistFAScoringModelFinancialView.FAScoreCardGroup);

      let oAPIParam: APIParam = new APIParam();
      oAPIParam.oFAScoringModelFinancialView = oFinancials;

      this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateFinancialFactorScore").then(
        result => this.OnSuccessGetFAScoringModelFinancialForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelFinancial(error))
    }

  }

  /// component public methods can be called from parent component

  public Refresh() {

    //console.log(this.__sInstanceId);
    //console.log(this.__sStateDataId);
    //console.log(this.__sValue);
    //console.log(this.__sDataCaption);

    this.__bIsLoadingVisible = true;
    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstanceAllStateData/" + this.__sInstanceId).then((Data) => {

      if (Data != null) {

        let sData: string = Data;

        sData = sData.replace(/\n/g, 'neewwlliine').replace(/\r/g, 'neewwlliine');
        //sData = this.replaceAllSpecialCharacters(sData);

        try {
          this.__oInstanceAllStateData = JSON.parse(sData);

          for (let oFSV of this.__oInstanceAllStateData) {
            if (oFSV.DataValue != undefined || oFSV.DataValue != null)
              oFSV.DataValue = this.replaceAllSpecialCharacters(oFSV.DataValue);
          }​​​

          this.__sScoringModelName = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sScoringModel).DataValue;

          let oAPIParam: APIParam = new APIParam();
          oAPIParam.Param = this.__sScoringModelName;

          oAPIParam.sBaseYearPeriod = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sPeriod).DataValue;
          oAPIParam.sBasePeriod = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sBasePeriod).DataValue;
          oAPIParam.sTradingcounterparty = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sTradingCounterparty).DataValue;

          if (!this.IsNullOrEmpty(this.__sQuantitativeControl) && (this.IsNullOrEmpty(this.__sValue) || this.__sValue == undefined)) {
            this.__sValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sQuantitativeControl).DataValue;
          }



          if (this.IsNullOrEmpty(this.__sValue)) {
            oAPIParam.sValue = "All";
          }
          else {
            oAPIParam.sValue = "Plain";
          }


          this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutFAScoringModelFinancialView").then(
            result => this.OnSuccessGetFAScoringModelFinancial(result)
          ).
            catch(error => this.OnErrorGetFAScoringModelFinancial(error))

        }
        catch
        {
          console.log(sData);
          this.__bIsLoadingVisible = false;
        }

      }

    });



  }


  public GetData() {
    let sXML: string = '';

    sXML += '<FinancialData>';
    sXML += '<ScoringModel>' + this.__sScoringModelName + '</ScoringModel>';


    for (let x of this.__oFAScoringModelFinancialView) {
      sXML += '<Data>';
      sXML += '<FinancialFactor>' + x.lFAScoringModelFinancialViewId + "</FinancialFactor>";

      if (!this.IsNullOrUndefined(x.OriginalValue)) {
        sXML += "<OriginalValue>" + x.OriginalValue + "</OriginalValue>";
      }
      else {
        sXML += "<OriginalValue></OriginalValue>";
      }

      if (!this.IsNullOrUndefined(x.AdjustedValue)) {
        sXML += '<AdjustedValue>' + x.AdjustedValue + "</AdjustedValue>";
      }
      else {
        sXML += "<AdjustedValue></AdjustedValue>";
      }

      if (!this.IsNullOrUndefined(x.Score)) {
        sXML += '<Score>' + x.Score + "</Score>";
      }
      else {
        sXML += "<Score></Score>";
      }

      if (!this.IsNullOrUndefined(x.Weight)) {
        sXML += '<Weight>' + x.Weight + "</Weight>";
      }
      else {
        sXML += "<Weight></Weight>";
      }

      if (!this.IsNullOrUndefined(x.WeightedScore)) {
        sXML += '<WeightedScore>' + x.WeightedScore + "</WeightedScore>";
      }
      else {
        sXML += "<WeightedScore></WeightedScore>";
      }

      if (!this.IsNullOrUndefined(x.GroupFormulaValue)) {
        sXML += '<GroupFormulaValue>' + x.GroupFormulaValue + "</GroupFormulaValue>";
      }
      else {
        sXML += "<GroupFormulaValue></GroupFormulaValue>";
      }

      sXML += '</Data>';
    }

    //let sJSONText:string = "";    

    //for (let x of this.__oFAScoringModelFinancialView)
    //{
    //  if (this.IsNullOrEmpty(sJSONText)) {
    //    sJSONText += "{\"QualitativeFactor\":" + "\"" + x.QualitativeFactor + "\",\"AdjustedValue\":" + "\"" + x.AdjustedValue + "\" }";
    //  }
    //  else {
    //    sJSONText += ", {\"QualitativeFactor\":" + "\"" + x.QualitativeFactor + "\",\"AdjustedValue\":" + "\"" + x.AdjustedValue + "\" }";
    //  }

    //}

    //sJSONText = "[" + sJSONText + "]";

    //sXML = sXML.replace("JSONText",sJSONText);

    sXML += '</FinancialData>';
    return sXML;
  }

  public OnErrorGetFAScoringModelFinancial(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }
  public OnSuccessGetFAScoringModelFinancial(response: any) {

    if (response != null) {
      let oFAScoringModelFinancialView: FAScoringModelFinancialView[] = [];
      oFAScoringModelFinancialView = response;

      this.__oQuantitativeGroup = [];
      this.__oQuantitativeScoreCardGroup = [];

      for (let x of oFAScoringModelFinancialView) {
        if (!this.IsNullOrEmpty(x.FAFinancialGroup)) {
          if (this.__oQuantitativeGroup.find(y => y.GroupName == x.FAFinancialGroup) == null) {
            let oFinancialGroup: QuantitativeGroup = new QuantitativeGroup();
            oFinancialGroup.GroupName = x.FAFinancialGroup;
            this.__oQuantitativeGroup.push(oFinancialGroup);
          }
        }

        if (!this.IsNullOrEmpty(x.FAScoreCardGroup)) {
          if (this.__oQuantitativeScoreCardGroup.find(y => y.GroupName == x.FAScoreCardGroup) == null) {
            let oFinancialGroup: QuantitativeGroup = new QuantitativeGroup();
            oFinancialGroup.GroupName = x.FAScoreCardGroup;
            this.__oQuantitativeScoreCardGroup.push(oFinancialGroup);
          }
        }

      }



      //for (let x of oFAScoringModelFinancialView.filter(x => x.IsScored == 1 && x.lFAScoreCardId != null && x.FAScoreCardGroup != null)) {
        
      //}

          

      this.__oFAScoringModelFinancialView = oFAScoringModelFinancialView;

        if (this.__oFAScoringModelFinancialView.filter(x => x.ConversionRate == null && x.FromCurrency != null).length > 0 && this.IsNullOrEmpty(this.__sValue)) {


          let oFV: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.ConversionRate == null && x.FromCurrency != null);

          this.__sExchangeRateWarningMessage = 'Please note that Currency Exchange Conversion Rate is not available between ' + oFV.FromCurrency + ' and ' + oFV.ToCurrency + ' on ' + oFV.ExchangeRateDate + '.';
        }
        else {
          this.__sExchangeRateWarningMessage = ''
        }

        if (!this.IsNullOrEmpty(this.__sValue)) {
          let sXML: string = this.__sValue;

          sXML = sXML.replace('<FinancialData>', '');
          sXML = sXML.replace('</FinancialData>', '');

          let iDefinitionStartIndex: number = 0;
          let iDefinitionLastIndex: number = 0;
          let sColumnData: string = "";


          iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
          iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

          sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

          let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

          sXML = sXML.replace(sColumnData, '');

          if (sScoringModel == this.__sScoringModelName) {

            let oFinancialColumns: string[] = ['FinancialFactor', 'OriginalValue', 'AdjustedValue', 'Score', 'Weight', 'WeightedScore','GroupFormulaValue'];

            let iStartIndex: number = 0;
            let iLastIndex: number = 0;
            let sXMLData: string = '';
            let sNode: string = '';
            let iColumnStartIndex: number = 0;
            let iColumnLastIndex: number = 0;
            let sColumnValue: string = "";
            let sValue: any = "";
            let sData: string = '';

            let oFinancialFactors: any[] = [];

            while (sXML.trim() != '') {
              let oFinancialFactor: any = {};

              iStartIndex = sXML.indexOf("<Data>");
              iLastIndex = sXML.indexOf("</Data>");

              sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

              sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

              for (let oColumn of oFinancialColumns) {
                iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

                if (iColumnStartIndex >= 0) {
                  iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

                  sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

                  sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

                }

                switch (oColumn) {
                  case 'FinancialFactor':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.FinancialFactor = sValue;
                      }
                      break;
                    }
                  case 'OriginalValue':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.OriginalValue = Number(sValue);
                      }
                      break;
                    }
                  case 'AdjustedValue':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.AdjustedValue = Number(sValue);
                      }
                      break;
                    }
                  case 'Score':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.Score = Number(sValue);
                      }
                      break;
                    }
                  case 'Weight':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.Weight = Number(sValue);
                      }
                      break;
                    }
                  case 'WeightedScore':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.WeightedScore = Number(sValue);
                      }
                      break;
                    }
                  case 'GroupFormulaValue':
                    {
                      if (sValue != 'null') {
                        oFinancialFactor.GroupFormulaValue = Number(sValue);
                      }
                      break;
                    }

                }
              }

              sXML = sXML.replace(sXMLData, '');
              oFinancialFactors.push(oFinancialFactor);

            }


            for (let x of oFinancialFactors) {
              let oFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(y => y.lFAScoringModelFinancialViewId == x.FinancialFactor);

              if (oFAScoringModelFinancialView != null) {

                oFAScoringModelFinancialView.OriginalValue = x.OriginalValue;
                oFAScoringModelFinancialView.AdjustedValue = x.AdjustedValue;
                oFAScoringModelFinancialView.Score = x.Score;
                oFAScoringModelFinancialView.Weight = x.Weight;
                oFAScoringModelFinancialView.WeightedScore = x.WeightedScore;
                oFAScoringModelFinancialView.GroupFormulaValue = x.GroupFormulaValue;
              }

              //iDefinitionStartIndex = sXML.indexOf("<Data>");
              //iDefinitionLastIndex = sXML.indexOf("</Data>");

              //sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 7);

              //let sJson: string = sColumnData.replace("<Data>", "").replace("</Data>", "");

              //sJson = sJson.replace(/doouubleQuote/g, '"');

              //let oQF: any = JSON.parse(sJson);

              //for (let x of oQF)
              //{
              //  let oFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(y => y.QualitativeFactor == x.QualitativeFactor);

              //  if (oFAScoringModelFinancialView != null) {

              //    if (x.AdjustedValue != 'null')
              //      oFAScoringModelFinancialView.AdjustedValue = x.AdjustedValue;

              //    if (oFAScoringModelFinancialView.IsScored == 1) {

              //      this.TextAreaOnChange(oFAScoringModelFinancialView.lFAScoringModelQualitativeId);

              //    }


              //  }

              //}


            }

          }

        }

      
    }
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetFAScoringModelFinancialForNewScore(response: any) {

    if (response != null) {
      let oFAScoringModelFinancialViews: FAScoringModelFinancialView[] = response;

      for (let oFAScoringModelFinancialView of oFAScoringModelFinancialViews)
      {
        let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialViewId == oFAScoringModelFinancialView.lFAScoringModelFinancialViewId);

        if (!this.IsNullOrUndefined(oExistFAScoringModelFinancialView)) {
          oExistFAScoringModelFinancialView.Score = oFAScoringModelFinancialView.Score;
          oExistFAScoringModelFinancialView.WeightedScore = oExistFAScoringModelFinancialView.Score * oExistFAScoringModelFinancialView.Weight;
        }
      }      

    }
    this.__bIsLoadingVisible = false;
  }


  public replaceAll(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'backslaaash')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101'); //.replace(/\\n/g, 'newline').replace(/\\r/g, 'newline').replace(/\\t/g, 'newline');
    return strToBeReturned;
  }

  public replaceFilePath(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/\\/g, 'bckwrdslsh101').replace(/:/g, 'cln100');
    return strToBeReturned;
  }

  public URLEncode(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/&/g, '%26');
    return strToBeReturned;
  }


  public IsNullOrEmpty(sValue: string) {
    if (sValue == undefined || sValue == '' || sValue == null || sValue.trim() == '') {
      return true;
    }
    else {
      return false;
    }
  }

  public IsNullOrUndefined(iValue: any) {
    if (iValue == undefined || iValue == null) {
      return true;
    }
    else {
      return false;
    }
  }

  public IsTrue(oValue: any) {
    if (oValue != undefined && (oValue == 1 || oValue.toString() == 'true')) {
      return true;
    }
    else {
      return false;
    }
  }
  private replaceAllSpecialCharacters(str: any) {
    let strToBeReturned = "";

    strToBeReturned = str.replace(/backslaaash/g, "\\\\").replace(/annnd/g, "&").replace(/pluuuus/g, "+").replace(/cln100/g, ":").replace(/leeesthan/g, "<").replace(/greeeterthan/g, ">").replace(/hassh/g, "#")
      .replace(/aaat/g, "@").replace(/staaar/g, "*").replace(/dolllaar/g, "$").replace(/perseent/g, "%").replace(/exclammmaation/g, "!").replace(/quoootes/g, '"').replace(/ampersand/g, "&"); //FB 30669 - Vidya

    return strToBeReturned;
  }

}
